import { DriverContractsListData } from "../../../../../../../common/services/driver/contracts/list/driver-contracts-list";
import BillingModel from "../../../../../../../common/types/billing-model";
import DriverContractListingBillingModel from "../../common/types/driver-contract-listing-billing-model";
import DriverContractListingByRailyListingItem from "./types/driver-contract-listing-by-raily-listing-item";

const createListingItemModel = (
  model: BillingModel,
): DriverContractListingBillingModel => {
  switch (model) {
    case BillingModel.AB:
      return DriverContractListingBillingModel.AB;
    case BillingModel.ABA:
      return DriverContractListingBillingModel.ABA;
    case BillingModel.OTHER:
      return DriverContractListingBillingModel.OTHER;
    case BillingModel.SABS:
      return DriverContractListingBillingModel.SABS;
  }
};

const createListingItem = (
  responseItem: DriverContractsListData,
): DriverContractListingByRailyListingItem => {
  return {
    uuid: responseItem.contractId,
    taxiCorporation: responseItem.companyName,
    billingModel: createListingItemModel(responseItem.model),
    distanceRate: responseItem.distanceRate,
    freeStoppingPeriodMinutes: responseItem.haltingTimeAfterMinutes,
    stoppingRate: responseItem.haltingTimeRate,
    periodOfValidity: {
      from: new Date(responseItem.validSince),
      to: new Date(responseItem.validTo),
    },
    isActive: responseItem.active,
  };
};

const createListingItems = (
  responseData: DriverContractsListData[],
): DriverContractListingByRailyListingItem[] => {
  return responseData.map(createListingItem);
};

const driverContractListingByRailyFactory = {
  createListingItems,
};

export default driverContractListingByRailyFactory;
